const config = {
  apiBase: process.env.REACT_APP_API_BASE,
  env: process.env.REACT_APP_ENV,
};
export default config;
